import { Button } from "@studyplus/boron-ui";
import { useSelector } from "react-redux";
import Icon from "../../components/atoms/Icon";
import PrintButton from "../../components/atoms/PrintButton";
import { FieldLayoutMultiRows } from "../../components/features/Schedule/FormParts";
import { SingleDatePickerWrapper } from "../../components/molecules/SingleDatePickerWrapper";
import AppStateInterface from "../../interfaces/AppStateInterface";
import OperatorPrivilegesStateInterface from "../../interfaces/OperatorPrivilegesStateInterface";
import styles from "./Menu.scss";
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalProvider,
  useModalState,
} from "./modal";
import { SectionScheduleFormFields } from "./SectionScheduleForm";

export const Menu = ({
  onDateChange,
  date,
}: {
  onDateChange: (date: Date) => void;
  date: Date;
}) => {
  const modalState = useModalState();
  const operatorPrivileges = useSelector<
    AppStateInterface,
    OperatorPrivilegesStateInterface
  >((state) => state.operatorPrivileges);
  return (
    <div className={styles.root}>
      <div>
        <Button
          className={`${styles.btn} ${styles.todaybtn}`}
          hoverVariant="filled"
          variant="outline"
          size="xs"
          onClick={() => onDateChange(new Date())}
        >
          今日
        </Button>
      </div>
      <div>
        <SingleDatePickerWrapper
          date={date}
          blockType="Nothing"
          onDateChange={(date) => {
            if (date) {
              onDateChange(date);
            }
          }}
        />
      </div>
      <div className={styles.rightMenu}>
        {operatorPrivileges.data !== null &&
          operatorPrivileges.data.role !== "limited_member" && (
            <Button
              size="xs"
              className={`${styles.btn} ${styles.addbtn}`}
              aria-label="予定の登録"
              onClick={modalState.openAddModal}
            >
              <Icon name="icon-plus-tag" />
            </Button>
          )}
        <PrintButton />
      </div>
      <ModalProvider value={modalState}>
        <Modal>
          {!modalState.isStudentTag ? (
            <ModalHeader>予定の登録</ModalHeader>
          ) : (
            <ModalHeader>
              <span
                onClick={modalState.openAddModal}
                className={styles.backBtn}
              >
                <FieldLayoutMultiRows>
                  <Icon
                    name="icon-arrow-close"
                    className={styles.backArrowIcon}
                  />
                  <p>戻る</p>
                </FieldLayoutMultiRows>
              </span>
            </ModalHeader>
          )}
          <ModalBody>
            <SectionScheduleFormFields initialDate={date} />
          </ModalBody>
        </Modal>
      </ModalProvider>
    </div>
  );
};
